// 這份檔案的主要功能是從瀏覽器的 window 上取已經定義的物件及類別 (例如 ov, GeoPoint)。
// 應對 pilotgaea-web/index.d.ts 的定義

// 對應定義檔 export * as ov from "./webgl/ov/ov"
const ov = window.ov;
export { ov };

// 對應定義檔 export * from "./common/geometry/index"
const Geo3DPoint = window.Geo3DPoint;
const GeoBoundary = window.GeoBoundary;
const GeoLine = window.GeoLine;
const GeoPoint = window.GeoPoint;
const GeoPolygon = window.GeoPolygon;
const GeoPolygonSet = window.GeoPolygonSet;
const GeoPolyline = window.GeoPolyline;
const GeoUtility = window.GeoUtility;
const CRect = window.CRect;
const CSize = window.CSize;
export { Geo3DPoint, GeoBoundary, GeoLine, GeoPoint, GeoPolygon, GeoPolygonSet, GeoPolyline, GeoUtility, CRect, CSize };

// 對應定義檔 export { GetEPSGEngine } from "./common/utility/EPSGEngine";
const GetEPSGEngine = window.GetEPSGEngine;
export { GetEPSGEngine };